import { render, staticRenderFns } from "./CBCS.vue?vue&type=template&id=1e68002a&"
import script from "./CBCS.vue?vue&type=script&lang=js&"
export * from "./CBCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports